import { render } from "./LeaderboardBase.vue?vue&type=template&id=28f0b7bf"
import script from "./LeaderboardBase.vue?vue&type=script&lang=js"
export * from "./LeaderboardBase.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./LeaderboardBase.vue?vue&type=style&index=0&id=28f0b7bf&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script